<template>
    <div class="row mb-3">
        <div class="col-lg-12 d-flex flex-column h-100">
            <div class="np-header1 np-pb-3">{{ $t("UI.dashboard.welcome") }}, {{ userStore.userShortName }}</div>

            <HomeNavigation activeTab="projectsAndSpaces" @callSwitchScreen="callSwitchScreen"/>

            <div class="row mb-3">
                <div class="col-lg-6">
                    <div class="np-fieldset np-pt-4">
                        <div class="np-group np-rounded-start np-p-2 align-items-center no-wrap">
                            <span class="pe-4 np-nowrap">{{ $t("UI.dashboard.mySpaces") }}:</span>
                        </div>   
                        <vSelect 
                            class="np-rounded-end align-items-center flex-grow-1 np-mr-2" 
                            placeholder="" 
                            v-model="selectedSpace"
                            label="title"
                            :clearable="false"
                            :options="listSpaces" 
                            :reduce="space => space.id"
                            @update:modelValue="handleSpaceSelect"
                        />
                        <button class="np-btn np-btn-info p-0 me-2" @click="handleSpaceDialog">
                            <svg><use href="@/assets/images/icons/plus.svg#icon"></use></svg>
                        </button>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="np-fieldset np-pt-4">
                        <div class="np-group np-rounded-start np-p-2 align-items-center no-wrap">
                            <span class="pe-4 np-nowrap">{{ $t("UI.dashboard.myProjects") }}:</span>
                        </div>   
                        <vSelect 
                            class="np-rounded-end align-items-center flex-grow-1 np-mr-2" 
                            placeholder="" 
                            v-model="selectedProject"
                            label="name"
                            :clearable="false"
                            :options="listProjects" 
                            :reduce="project => project.id"
                            @update:modelValue="handleProjectSelect"
                         />
                        <button class="np-btn np-btn-info p-0 me-2" @click="handleProjectDialog">
                            <svg><use href="@/assets/images/icons/plus.svg#icon"></use></svg>
                        </button>
                    </div>
                </div>                
            </div>

            <div class="row mt-4" v-if="selectedProject">
                <div class="col-lg-5">
                    <div class="np-header3 vertical-align-center np-pb-2">
                        <svg class="np-mr-2"><use href="@/assets/images/icons/list.svg#icon"></use></svg> {{ $t("UI.dashboard.generalInformation") }} 
                    </div>
                    <div class="np-panel p-2 mb-3">
                        <div class="np-panel-body">
                            <div class="np-group align-items-center mb-1">
                                <svg class="np-mr-2"><use href="@/assets/images/icons/team-user.svg#icon"></use></svg> 
                                <span class="me-2">{{ $t("UI.project.projectAuthor") }}:</span><a href="#">Иванов Иван</a>
                            </div>
                            <div class="np-group align-items-center mb-1">
                                <svg class="np-mr-2"><use href="@/assets/images/icons/team-user.svg#icon"></use></svg> 
                                <span class="me-2">{{ $t("UI.project.projectDirector") }}:</span><a href="#">Иванов Иван</a>
                            </div>  
                            <div class="np-group align-items-center mb-1">
                                <svg class="np-mr-2"><use href="@/assets/images/icons/team.svg#icon"></use></svg> 
                                <span class="me-2">{{ $t("UI.project.projectMembers") }}:</span><a href="#">10</a>
                            </div>                               
                            <div class="np-group align-items-center mb-1">
                                <svg class="np-mr-2"><use href="@/assets/images/icons/team.svg#icon"></use></svg> 
                                <span class="me-2">{{ $t("UI.project.dateStart") }}:</span><a href="#">{{ this.localeDate(this.selectedProject?.date_create) }}</a>
                            </div>                               
                            <div class="np-group align-items-center mb-1">
                                <svg class="np-mr-2"><use href="@/assets/images/icons/team.svg#icon"></use></svg> 
                                <span class="me-2">{{ $t("UI.project.dateFinish") }}:</span><a href="#">{{ this.localeDate(this.selectedProject?.date_planned_end) }}</a>
                            </div>                                                                                                                
                        </div>
                    </div>
                    <div class="np-header3 vertical-align-center pt-2 pb-2">
                        <svg class="np-mr-2"><use href="@/assets/images/icons/wallet.svg#icon"></use></svg> {{ $t("UI.project.budget") }}
                    </div>  
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="np-panel mb-3">
                                <div class="np-panel-body align-items-center">
                                    <div class="np-group">{{ $t("UI.dashboard.planned") }} <span class="np-color-primary-500 ms-2">{{ this.selectedProject?.budget.budget_plan }}</span></div>
                                </div>                            
                            </div>    
                        </div>
                        <div class="col-lg-6">
                            <div class="np-panel mb-3">
                                <div class="np-panel-body align-items-center">
                                    <div class="np-group">{{ $t("UI.dashboard.spent") }} <span class="np-color-crimson ms-2">{{ this.selectedProject?.budget.actual_sum }}</span></div>
                                </div>                            
                            </div>                
                        </div>                                
                    </div>                  
                </div>
                <div class="col-lg-4 d-flex flex-column">
                    <div class="np-header3 vertical-align-center pb-2">
                        <svg class="np-mr-2"><use href="@/assets/images/icons/list.svg#icon"></use></svg> {{ $t("UI.project.description") }}
                    </div>
                    <div class="np-panel flex-grow-1 mb-3">
                        <div class="np-panel-body flex-grow-1">
                            <p class="np-f-medium mb-2">{{ this.selectedProject?.name }}</p>
                            <p>{{ this.selectedProject?.description }}</p>
                        </div>
                        <div class="np-panel-footer justify-content-end" v-if="this.selectedProject">
                            <a class="np-btn np-link" :href="'/project/' + this.selectedProject?.id">
                                {{ $t("UI.dashboard.gotoProject") }}
                                <svg class="ms-1"><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 d-flex flex-column">
                    <div class="np-header3 vertical-align-center pb-2">
                        <svg class="me-2"><use href="@/assets/images/icons/pie-chart.svg#icon"></use></svg> {{ $t("UI.project.percentComplete") }}
                    </div>
                    <div class="np-panel flex-grow-1 mb-3">
                            <div class="np-group np-group-column">
                                <div class="flex-grow-1 p-2 pt-3 pb-0">
                                    <div class="progress-container">
                                        <div class="progress-value">{{ chartPercentData?.datasets[0].data[0] }}%</div>
                                        <div class="chart-container">
                                            <Doughnut
                                                :data="chartPercentData"
                                                :options="chartPercentOptions"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-grow-1 p-2" style="border-top: 1px solid #E7EBEF;">
                                    <div class="np-group np-group-column pt-3 px-3">
                                        <div class="np-group align-items-center">
                                            <span class="np-bullet np-mr-2" style="background-color: #405B7C"></span>
                                            <span>{{ $t("UI.project.taskCount") }}: 16</span>
                                        </div>
                                        <div class="np-group align-items-center pt-2">
                                            <span class="np-bullet np-mr-2" style="background-color: #86EFAC"></span>
                                            <span>{{ $t("UI.project.taskCompleted") }}: 15</span>
                                        </div>
                                        <div class="np-group align-items-center pt-2">
                                            <span class="np-bullet np-mr-2" style="background-color: #FCA5A5"></span>
                                            <span>{{ $t("UI.project.taskExpired") }}: 3</span>
                                        </div>
                                        <div class="np-group align-items-center py-2">
                                            <span class="np-bullet np-mr-2" style="background-color: #FFEF90"></span>
                                            <span>{{ $t("UI.project.workload") }}</span>
                                        </div>                                                                                                                        
                                    </div>
                                </div>
                            
                        </div>
                    </div>
                </div>                                
            </div>

            <div class="row mt-4" v-if="selectedProject">
                <div class="col-lg-12">
                    <div class="np-header3 vertical-align-center pb-2">
                        <svg class="me-2"><use href="@/assets/images/icons/chart-line2.svg#icon"></use></svg> Линейный график
                    </div>
                </div>
                <div class="col-lg-3 h-100">
                    <div class="np-panel">
                        <div class="np-panel-body">
                            Данные графиков
                        </div>
                    </div>                    
                </div>
                <div class="col-lg-9 h-100">
                    <div class="np-panel">
                        <div class="np-panel-body">
                            Графики
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row h-100" v-if="!!!selectedProject">
            <div class="col-lg-12 text-center h-100">

            </div>
        </div>
    </div>
 
    <AddSpaceModal modalID="addSpaceModalID" ref="AddSpaceModal" class="cobalt-base-dialog">
        <template v-slot:header-left>{{ $t("UI.addCompany") }}</template>
        <template v-slot:body>
            <div class="modal-body ps-3 pe-3">
                <div class="row m-0 w-100 h-100">
                    <div class="col">
                        <form>
                            <div class="mb-3">
                                <label for="spaceTitle">{{ $t("UI.name") }}:</label>
                                <input type="text" class="form-control-log" id="spaceTitle"
                                    v-model="spaceData.title">
                                <small id="titleHelp" class="form-text text-muted"></small>
                            </div>
                            <div class="mb-4">
                                <label for="spaceDesc">{{ $t("UI.description") }}:</label>
                                <textarea class="form-control-log" id="spaceDesc"
                                    v-model="spaceData.description"></textarea>
                            </div>

                            <div v-if="spaceData.errorText != ''">
                                <p class="mt-2 mb-0 text-danger">{{ spaceData.errorText }}</p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal-footer p-3">
                <button type="button" class="np-btn np-danger px-4" data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
                <button type="button" class="np-btn np-success-filled px-4" data-bs-dismiss="modal" @click="addSpace">{{ $t("UI.add") }}</button>
            </div>            
        </template>
    </AddSpaceModal>

    <DelSpaceModal modalID="delSpaceModalID" modalPosition="center" ref="DelSpaceModal" class="cobalt-base-dialog">
        <template v-slot:header-left>{{ $t("UI.deleteProject") }}</template>
        <template v-slot:body>
            <div class="modal-body">
                <h2>{{ $t("UI.confirmation") }}</h2>
            </div>
            <div class="modal-footer p-1">
                <button type="button" class="btn btn-outline-secondary btn-sm me-1"
                    data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
                <button type="button" class="btn btn-danger btn-sm" @click="deleteCompany">{{ $t("UI.delete") }}</button>
            </div>
        </template>
    </DelSpaceModal>  

    <DelProjectModal modalID="delProjectModalID" ref="DelProjectModal" class="cobalt-base-dialog">
        <template v-slot:header-left>{{ $t("UI.deleteProject") }}</template>
        <template v-slot:body>
            <div class="modal-body">
                <h2>{{ $t("UI.confirmation") }}</h2>
            </div>
            <div class="modal-footer p-0 pb-3">
                <button type="button" class="btn btn-outline-secondary btn-sm me-1"
                    data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
                <button type="button" class="btn btn-danger btn-sm" @click="deleteProject">{{ $t("UI.delete") }}</button>
            </div>
        </template>
    </DelProjectModal> 

    <AddProjectModal 
        modalID="addProjectModalID"
        @refresh="refreshProjects"
        ref="AddProjectModal">
    </AddProjectModal>

</template>

<script>
import { useSettingsStore } from "@/stores/settingsStore"
import { useUserStore } from '@/stores/userStore'

import AddSpaceModal from "@/components/modals/BsModal.vue"
import DelSpaceModal from "@/components/modals/BsModal.vue"
import AddProjectModal from "@/components/modals/ProjectModal.vue"
import DelProjectModal from "@/components/modals/BsModal.vue"

import HomeNavigation from "@/components/dashboard/home/Navigation.vue"
import { createToast } from 'mosha-vue-toastify'  
import { mapGetters, mapActions } from 'vuex'
import { nameColor, localeDate, localeTime, localeDateTime, formatBytes, priorityOptions, eventDate, priorityValues } from '@/utils/format'
import Config from '../../../config'
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
    components: {
        HomeNavigation,
        AddSpaceModal,
        DelSpaceModal,
        AddProjectModal,
        DelProjectModal,
        Doughnut
    },
    data() {
        return {
            Config,
            isLoading: false,
            listSpaces: [],
            listProjects: [],
            selectedSpace: null,
            selectedProject: null,
            spaceData: {
                id: 0,
                title: '',
                description: '',
                errorText: ''
            },
            projectData: {},            
        }
    },
    async beforeMount() {
        this.getListSpaces()
    },
    computed: {  
        settings() {
            return useSettingsStore()
        },
        userStore() {
            return useUserStore()
        },    
        chartPercentData: {
            get() {
                const incomplete = Math.round(Math.random() * 100)
                return {
                    labels: ['Выполненные', 'Оставшиеся'],
                    datasets: [
                        {
                            data: [100 - incomplete, incomplete],
                            backgroundColor: ['#86EFAC', '#FCA5A5'],
                            borderWidth: 0,
                        },
                    ],
                }
            }
        },
        chartPercentOptions: {
            get() {
                return {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            enabled: false,
                        },
                        datalabels: {
                            display: false
                        }                                              
                    },
                    cutout: '70%',
                    rotation: -90,
                    circumference: 180,                
                }
            }
        },                            
    },
    methods: {
        ...mapActions('company', ['info', 'list', 'addCompany', 'delete']),
        ...mapGetters('company', { getInfo: 'getInfo', companyList: 'getList'}),
        ...mapActions('project', { getProjectInfo: 'info', projectsList: 'list', addProject: 'saveProject', projectDelete: 'delete' }),
        ...mapGetters('project', { getProjectsList: 'getList' }), 

        localeDate,
       
        async attachSettings() {
            

            if (this.settings.defaultSpace > 0) {
                await this.handleSpaceSelect(this.settings.defaultSpace)
            } else {
                if (this.listSpaces.length > 0) {
                    await this.handleSpaceSelect(this.listSpaces[0].id)
                }
            }
        },

        async getListSpaces() {
            await this.list([600, 400])
            this.listSpaces = this.companyList()

            this.attachSettings()
        },

        async getListProjects(spaceId) {
            let dataParam = {
                pic_h: 400,
                pic_w: 600,
                company_id: spaceId
            } 

            await this.projectsList(dataParam)
            this.listProjects = this.getProjectsList()  

            if (this.settings.defaultProject > 0) {
                this.handleProjectSelect(this.settings.defaultProject)
            } else {
                if (this.listProjects.length > 0) {
                    this.handleProjectSelect(this.listProjects[0].id)
                }
            }
        },

        async refreshProjects(newProject) {
            if (newProject) {
                this.settings.defaultProject = newProject.id
            }

            await this.getListProjects(this.selectedSpace.id)
        },

        callSwitchScreen(target) {
            this.$emit("switchScreen", target)
        },
        
        async handleSpaceSelect(spaceId) {
            if (this.settings.defaultSpace != spaceId) {
                this.settings.defaultSpace = spaceId
                this.settings.defaultProject = 0
            }

            this.selectedSpace = this.listSpaces.find(s => s.id === spaceId)
            this.selectedProject = null
            if (this.selectedSpace) {
                await this.getListProjects(this.selectedSpace.id)
            }
        },

        async handleProjectSelect(projectId) {
            this.settings.defaultProject = projectId

            this.selectedProject = this.listProjects.find(p => p.id === projectId)

            this.isLoading = true

            this.projectData = await this.getProjectInfo(projectId)

            console.log(this.projectData)

            this.isLoading = false
        }, 

        handleSpaceDialog() {
            this.$refs.AddSpaceModal.shows()
        },

        handleProjectDialog() {
            if (!this.selectedSpace) {
                createToast({ description: this.$t("message.selectSpace") }, Config.TOAST_CONFIG_WARNING) 
                return
            }
            this.$refs.AddProjectModal.shows(this.selectedSpace.id, null);
        },

        async addSpace() {
            await this.addCompany(this.spaceData)
            await this.getListSpaces()
            this.$refs.AddSpaceModal.hide()
        },        
    }

}
</script>

<style scoped>
.progress-container {
  position: relative;
  height: 100px;
}

.progress-value {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0%);
  font-size: 32px;
  font-weight: 500;
  color: #393939;
}

.chart-container {
  width: 100%;
  height: 100%;
}
</style>